/* Per-element ownership for sections replaced by Shopify's theme editor. */
(() => {
 'use strict';
 function create({selector,setup}){
  const instances=new Map();
  const dispose=node=>{const instance=instances.get(node);instance?.dispose?.();instances.delete(node);};
  function mount(root){
   for(const node of instances.keys())if(node.isConnected===false)dispose(node);
   const nodes=[...(root.matches?.(selector)?[root]:[]),...root.querySelectorAll(selector)];
   for(const node of nodes)if(!instances.has(node))instances.set(node,setup(node));
  }
  function unmount(root){for(const node of instances.keys())if(node===root||root.contains(node)||node.isConnected===false)dispose(node);}
  return {mount,unmount,get:node=>instances.get(node),forEach:fn=>instances.forEach((value,node)=>fn(value,node))};
 }
 window.LiotroLifecycle={create};
})();
